import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { pdf } from '@react-pdf/renderer';
import ExperienceCertificatePDF from '../pdf/ExperienceCertificate';
import logo from '../img/icons/vakra_logo_1024x1024.png';
import complete_logo from '../img/complete_snap_1.png';
import SignaturePad from '../components/SignaturePad';
import signatureImage from '../img/sign.png'
import shikka from '../img/stamp.png'
import JoiningLetterPDF from '../pdf/JoinigLetterPDF';
import NOCCertificatePDF from '../pdf/NOC';
import ExperienceWhomsoeverPDF from '../pdf/Exp';
import ExperienceCertificateIntern from '../pdf/ExperianceCertificateIntern';
const ExperienceCertificate = () => {
    const [form, setForm] = useState({
        name: 'Vidyacharan Ningule',
        designation: 'Web Development Intern',
        startDate: '2025-12-08',
        endDate: '2026-04-27',
        duties: '',
        companyName: 'Vakralabs Services',
        companyAddress1: 'Address : C-902, Bhalchandra Akashvan, Punawale,',
        companyAddress2: 'Pimpri-Chinchwad, Maharashtra-411033 (India)',
        contact: 'Phone: +91 9423 886 986 | Email: info@vakralabs.com',
        companyWebsite: 'https://vakralabs.com',
        signatoryName: 'Navnath Atmaram Adsul',
        signatoryTitle: 'Chief Technology Officer',
        signatureImageUrl: '',
        stampImageUrl: '',
        
    });
    const [showSignaturePad, setShowSignaturePad] = useState(false);

    const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const download = async () => {
        const doc = <ExperienceWhomsoeverPDF
            employee={{ ...form }}
            companyName={form.companyName}
            companyLogo={logo}
            companyAddress1={form.companyAddress1}
            companyAddress2={form.companyAddress2}
            contact={form.contact}
            companyWebsite={form.companyWebsite}
            signatoryName={form.signatoryName}
            signatoryTitle={form.signatoryTitle}
            signatureImage={signatureImage}
            stampImage={form.stampImageUrl}
            issueDate={new Date()}
            complete_logo={complete_logo}
            shikka = {shikka}
        />;

        const blob = await pdf(doc).toBlob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `experience_${form.name.replaceAll(' ', '_') || 'experience_certificate'}.pdf`;
        a.click();
        URL.revokeObjectURL(url);
    };

    return (
        <div className="container mt-4">
            <div className="mb-3">
                <Link className="navbar-brand d-flex align-items-center" to="/">
                    <img src={logo} alt="VakraLabs" style={{ height: '50px' }} className="me-2" />
                    <div>
                        <div>Vakralabs Services</div>
                        <div className="text-muted d-none d-md-block" style={{ fontSize: '0.6rem', fontFamily: 'cursive' }}>Simplifying Complexity to Deliver Creativity</div>
                    </div>
                </Link>
            </div>
            <h3>Generate Experience Certificate</h3>
            <div className="card p-3">
                <div className="mb-2">
                    <label className="form-label">Employee Name</label>
                    <input className="form-control" name="name" value={form.name} onChange={onChange} />
                </div>
                <div className="mb-2">
                    <label className="form-label">Designation</label>
                    <input className="form-control" name="designation" value={form.designation} onChange={onChange} />
                </div>
                <div className="row">
                    <div className="col-md-6 mb-2">
                        <label className="form-label">Start Date</label>
                        <input type="date" className="form-control" name="startDate" value={form.startDate} onChange={onChange} />
                    </div>
                    <div className="col-md-6 mb-2">
                        <label className="form-label">End Date</label>
                        <input type="date" className="form-control" name="endDate" value={form.endDate} onChange={onChange} />
                    </div>
                </div>

                <div className="mb-2">
                    <label className="form-label">Duties (comma separated)</label>
                    <textarea className="form-control" name="duties" value={form.duties} onChange={onChange} rows={3} />
                </div>

                <div className="mb-2">
                    <label className="form-label">Company Address Line 1</label>
                    <input className="form-control" name="companyAddress1" value={form.companyAddress1} onChange={onChange} />
                </div>
                <div className="mb-2">
                    <label className="form-label">Company Address Line 2</label>
                    <input className="form-control" name="companyAddress2" value={form.companyAddress2} onChange={onChange} />
                </div>

                <div className="mb-2">
                    <label className="form-label">Contact Details</label>
                    <input className="form-control" name="contact" value={form.contact} onChange={onChange} />
                </div>

                <div className="mb-2">
                    <label className="form-label">Company Website</label>
                    <input className="form-control" name="companyWebsite" value={form.companyWebsite} onChange={onChange} />
                </div>

                <div className="row">
                    <div className="col-md-6 mb-2">
                        <label className="form-label">Signatory Name</label>
                        <input className="form-control" name="signatoryName" value={form.signatoryName} onChange={onChange} />
                    </div>
                    <div className="col-md-6 mb-2">
                        <label className="form-label">Signatory Title</label>
                        <input className="form-control" name="signatoryTitle" value={form.signatoryTitle} onChange={onChange} />
                    </div>
                </div>

                <div className="mb-2">
                    <label className="form-label">Signature Image URL (optional)</label>
                    <input className="form-control" name="signatureImageUrl" value={form.signatureImageUrl} onChange={onChange} placeholder="https://.../signature.png" />
                    <div className="mt-2 d-flex gap-2 align-items-center">
                        <button className="btn btn-outline-secondary btn-sm" onClick={() => setShowSignaturePad(true)}>Draw Signature</button>
                        {form.signatureImageUrl && (
                            <img src={form.signatureImageUrl} alt="signature" style={{ height: 40 }} className="ms-2" />
                        )}
                    </div>
                </div>

                <div className="mb-2">
                    <label className="form-label">Stamp Image URL (optional)</label>
                    <input className="form-control" name="stampImageUrl" value={form.stampImageUrl} onChange={onChange} placeholder="https://.../stamp.png" />
                </div>

                <div className="d-flex gap-2">
                    <button className="btn btn-teal" onClick={download}>Download PDF</button>
                </div>
                {showSignaturePad && (
                    <div className="mt-3">
                        <SignaturePad
                            width={600}
                            height={150}
                            onSave={(dataUrl) => {
                                setForm({ ...form, signatureImageUrl: dataUrl });
                                setShowSignaturePad(false);
                            }}
                            onClose={() => setShowSignaturePad(false)}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default ExperienceCertificate;
